/**
 * Read-only view of whether there is a confirmed, authenticated session.
 *
 * Authenticated data stores gate their network fetches on this: a request to a
 * protected endpoint (GetUserDefaults, GetAllProfiles, ...) must never leave the
 * browser unless the session has been verified. `isLoggedIn` is the single
 * source of that truth - it is set only after `verifyAuthentication()` confirms
 * the token with the backend, and cleared together with the token on
 * `forceLogout()`, so gating on it makes "fired an authenticated call without a
 * session" impossible by construction rather than something the interceptor has
 * to clean up after.
 */
export function useSessionGuard() {
	// Shape mirrors useAuth's `lcp-auth` factory so whichever composable seeds the
	// state first produces the same object.
	const authState = useState('lcp-auth', () => ({
		isLoggedIn: false,
		isLoggingIn: false,
		userID: null as string | null,
	}));

	const hasSession = computed(() => authState.value.isLoggedIn === true);

	return { hasSession };
}
